import React from "react";
import clsx from "clsx";

import { IPortfolio, TKeyValue, IPortfolioIssueAnswer } from "../../../state";

import styles from "./PortfolioTable.module.scss";

export interface IKeyTable {
  answer: string | null;
}

export interface ILessonTable {
  portfolio: IPortfolio;
  teachingMaterialName: string;
}

export interface ISummaryTable {
  answer: string | null;
}

const LESSONS_TOTAL_NUMBER = 4;

const Key: React.FC<IKeyTable> = ({ answer }) => {
  return (
    <table className={clsx(styles.table, styles.keyTable)}>
      <tbody>
        <tr>
          <td>かっこいい 大人って どんな大人？</td>
          <td>{answer ?? ""}</td>
        </tr>
      </tbody>
    </table>
  );
};

const Lesson: React.FC<ILessonTable> = ({
  portfolio,
  teachingMaterialName,
}) => {
  const noSencondAnswerAndSummary = React.useMemo(
    () => [11, 12, 17].includes(portfolio.portfolio_type),
    [portfolio.portfolio_type],
  );
  const firstSummaryAnswer = portfolio.summary_issue_answers?.find(
    answer => answer.order_num === 0,
  );
  const secondSummaryAnswer = portfolio.summary_issue_answers?.find(
    answer => answer.order_num === 1,
  );

  return (
    <table className={clsx(styles.table, styles.lessonTable)}>
      <thead>
        <tr>
          <th />
          <th>どんなことに気づき、学べたか</th>
          {!noSencondAnswerAndSummary && <th>どう活かせるか</th>}
        </tr>
      </thead>
      <tbody>
        {Array.from({ length: LESSONS_TOTAL_NUMBER }, (_, i) => {
          if (![1, 11].includes(portfolio.portfolio_type) && i === 0)
            return null;

          const issueAnswers: IPortfolioIssueAnswer[] = (portfolio as TKeyValue)[
            `lesson0${i}_issue_answers`
          ];
          const firstIssueAnswer = issueAnswers?.find(
            answer => answer.order_num === 0,
          );
          const secondIssueAnswer = issueAnswers?.find(
            answer => answer.order_num === 1,
          );

          return (
            <tr key={i}>
              <td>
                {[7, 17].includes(portfolio.portfolio_type) &&
                i === LESSONS_TOTAL_NUMBER - 1
                  ? "Last Lesson"
                  : `Lesson0${i}`}
                <br />
                振り返り
              </td>
              <td>{firstIssueAnswer?.content ?? ""}</td>
              {!noSencondAnswerAndSummary && (
                <td>{secondIssueAnswer?.content ?? ""}</td>
              )}
            </tr>
          );
        })}
        {portfolio.portfolio_type !== 7 && !noSencondAnswerAndSummary && (
          <tr>
            <td>{`${teachingMaterialName} 全体振り返り`}</td>
            <td>{firstSummaryAnswer?.content ?? ""}</td>
            <td>{secondSummaryAnswer?.content ?? ""}</td>
          </tr>
        )}
      </tbody>
    </table>
  );
};

const Summary: React.FC<ISummaryTable> = ({ answer }) => {
  return (
    <table className={clsx(styles.table, styles.summaryTable)}>
      <thead>
        <tr>
          <th>HOMEWORK ENAGEED CORE まとめ</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>{answer ?? ""}</td>
        </tr>
      </tbody>
    </table>
  );
};

export default {
  Key,
  Lesson,
  Summary,
};
